
// Generated from  PortalManagement.cs

import {ApiRequestAsync} from "./ApiRequest";
import {Promise} from 'es6-promise';
import {InputType,InputText,InputNumber,InputBoolean,InputChoice,InputFile,InputDate,PrivilegeMembership,FileNote,LanguageInfo,RemoveQuery,FilterMode,ValueCaptionPair} from "./Shared";


export function setCurrentPortalSettingsAsync(portalSettingsId : string): Promise<PortalSettings> {
  return ApiRequestAsync<PortalSettings>('IPortalManagementApi', 'SetCurrentPortalSettingsAsync', portalSettingsId);
}

export function getPortalSettingsAsync(portalSettingsId : string): Promise<PortalSettings> {
  return ApiRequestAsync<PortalSettings>('IPortalManagementApi', 'GetPortalSettingsAsync', portalSettingsId);
}

export function deletePortalSettingsAsync(portalSettingsId : string): Promise<boolean> {
  return ApiRequestAsync<boolean>('IPortalManagementApi', 'DeletePortalSettingsAsync', portalSettingsId);
}

export function savePortalSettingsAsync(settings : PortalSettings): Promise<PortalSettings> {
  return ApiRequestAsync<PortalSettings>('IPortalManagementApi', 'SavePortalSettingsAsync', settings);
}


export function getApplicationContextAsync(): Promise<ApplicationContext> {
  return ApiRequestAsync<ApplicationContext>('IPortalManagementApi', 'GetApplicationContextAsync');
}

export function getIsConnectedAsync(): Promise<boolean> {
  return ApiRequestAsync<boolean>('IPortalManagementApi', 'GetIsConnectedAsync');
}

export function getCurrentPortalSettingsAsync(): Promise<PortalSettings> {
  return ApiRequestAsync<PortalSettings>('IPortalManagementApi', 'GetCurrentPortalSettingsAsync');
}

export function getAllPortalSettingsAsync(): Promise<PortalSettings[]> {
  return ApiRequestAsync<PortalSettings[]>('IPortalManagementApi', 'GetAllPortalSettingsAsync');
}

export function getPortalInfosAsync(): Promise<PortalInfo[]> {
  return ApiRequestAsync<PortalInfo[]>('IPortalManagementApi', 'GetPortalInfosAsync');
}



import {observable, IObservableArray} from "mobx";

 
export class ApplicationContext {     
	@observable applicationTitle: string = "";    
	@observable version: string = "";    
	@observable portalSettings: PortalSettings = new PortalSettings();    
	@observable sessionDetails: SessionDetails = new SessionDetails();    
	contentLanguages: IObservableArray<LanguageInfo> = observable.array([]);    
	userInterfaceLanguages: IObservableArray<LanguageInfo> = observable.array([]);
	documentWildCardSearch: boolean;
}
 
export class PortalSettings {     
	@observable id: string = "";    
	@observable name: string = "";    
	@observable url: InputText = new InputText();    
	@observable userName: string = "";    
	@observable password: string = "";    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";
}
 
export class PortalInfo {     
	@observable id: string = "";    
	@observable name: string = "";    
	@observable isCurrent: boolean;
}
 
export class SessionDetails {     
	@observable isApp: boolean;    
	@observable isConnected: boolean;    
	@observable portalSettingsId: string = "";    
	@observable portalSettingsName: string = "";    
	@observable userDisplayName: string = "";    
	@observable isAnonymous: boolean;    
	@observable uiLanguage: string = "";    
	@observable isDocumentManager: boolean;    
	@observable isMetaDataManager: boolean;    
	@observable isBrandingManager: boolean;    
	@observable isLogging: boolean;    
	@observable isDebuggerAttached: boolean;    
}



export function _ignoreCompilerError_TS6133(x: any) : boolean {
  return (x instanceof InputText) || 
		 (x instanceof InputBoolean) || 
		 (x instanceof InputChoice) || 
		 (x instanceof InputDate) ||
		 (x instanceof InputFile) || 
		 (x instanceof PrivilegeMembership) || 
		 (x instanceof FileNote) || 
		 (x instanceof LanguageInfo) || 
		 (x instanceof RemoveQuery);
}

